import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { People, QuickLinkApiClient, fetchFromNewApi } from '~/services/Http';

export const GET_EMPLOYEE_QUICK_LINKS_SWR_KEY =
  'QuickLinkApiClient.getEmployeeQuickLinks';

// TODO: remove after regenerating http clients and adding full param to swagger
export function useGetEmployeeQuickLinksTemp(args?: {
  lang?: string;
  offset?: number;
  limit?: number;
  order?: People.Order20;
  full?: boolean;
}): UseSWROutput<People.QuickLinkDto[]> {
  const argKeys = (args ? Object.keys(args) : []) as Array<
    'lang' | 'offset' | 'limit' | 'order' | 'full'
  >;
  const queryParams = argKeys.reduce((params, argKey) => {
    if (!args || !args[argKey]) {
      return params;
    }

    if (!params) {
      return `${argKey}=${args[argKey]}`;
    }

    return `${params}&${argKey}=${args[argKey]}`;
  }, '');

  return useSWR(
    [
      GET_EMPLOYEE_QUICK_LINKS_SWR_KEY,
      args?.lang ?? undefined,
      args?.offset ?? undefined,
      args?.limit ?? undefined,
      args?.order ?? undefined,
      args?.full ?? undefined,
    ],
    () =>
      fetchFromNewApi(`/people/employees/me/quick-links?${queryParams}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.json())
        .then((r) => r.data),
    { refreshInterval: 0 },
  );
}

export function useGetEmployeeQuickLinks(args?: {
  lang?: string;
  offset?: number;
  limit?: number;
  order?: People.Order20;
}): UseSWROutput<People.QuickLinkDto[]> {
  return useSWR(
    [
      GET_EMPLOYEE_QUICK_LINKS_SWR_KEY,
      args?.lang ?? undefined,
      args?.offset ?? undefined,
      args?.limit ?? undefined,
      args?.order ?? undefined,
    ],
    ([_url, lang, offset, limit, order]) =>
      QuickLinkApiClient.getEmployeeQuickLinks(order, offset, limit, lang).then(
        (r) => r.data,
      ),
  );
}
